import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { RichText } from "../../models";
import {
  BlockHeader,
  HeaderLevel,
} from "../../../common/block-header/BlockHeader";
import { BlockBody } from "../../../common/block-body/BlockBody";
import { ContactForm } from "./components/contact-form/ContactForm";

type Props = {
  title: RichText;
  text: RichText;
  formId: string;
};

export const ContestContact: FC<Props> = ({ title, text, formId }) => {
  return (
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce className="w-full">
      <div
        className={classNames(
          "mt-20 bg-dark px-5 py-20",
          "lg:mt-25 lg:px-16 lg:py-25",
          "xl:mt-40 xl:px-24 xl:py-30",
        )}
      >
        <div
          className={classNames(
            "flex flex-col gap-y-5",
            "md:mx-auto md:flex-row md:justify-between",
            "lg:max-w-[984px]",
          )}
        >
          <div className={classNames("md:w-[38%]")}>
            <BlockHeader
              richText={title}
              headerLevel={HeaderLevel.H2}
              className={classNames(
                "mb-2.5 text-regular text-primary-content",
                "md:mb-5 md:text-medium",
                "lg:text-large",
              )}
            />
            <div className={classNames("text-regular text-base-400")}>
              <BlockBody richText={text} />
            </div>
          </div>
          <div className={classNames("md:w-[48%]")}>
            <ContactForm formId={formId} />
          </div>
        </div>
      </div>
    </Fade>
  );
};
